"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var MarketplaceConfigClientImpl_1 = __importDefault(require("./MarketplaceConfigClientImpl"));
var MarketplaceConfigAsyncClientImpl_1 = __importDefault(require("./MarketplaceConfigAsyncClientImpl"));
var MarketplaceConfigClientProvider = /** @class */ (function () {
    function MarketplaceConfigClientProvider() {
        this.CONTEXTUAL_PARAMETERS = ["acs_marketplace_id"];
        this.STAGE_VERSION_LABEL_NAME = "AcsMarketplaceConfig";
        this.TABLE_NAME = "acs_MarketplaceConfig";
    }
    MarketplaceConfigClientProvider.prototype.createTypeSafeClient = function (configSet) {
        return new MarketplaceConfigClientImpl_1.default(configSet);
    };
    MarketplaceConfigClientProvider.prototype.createTypeSafeAsyncClient = function (configSet) {
        return new MarketplaceConfigAsyncClientImpl_1.default(configSet);
    };
    return MarketplaceConfigClientProvider;
}());
exports.default = MarketplaceConfigClientProvider;
